var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnigma(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 600 169.9",
    style: {
      enableBackground: "new 0 0 600 169.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#000000;stroke-width:5.4956;stroke-miterlimit:10;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;}\n\t.st2{fill:#D5489A;}\n\t.st3{fill:#36ABE1;}\n\t.st4{fill:#005CA0;}\n\t.st5{fill:none;stroke:#000000;stroke-width:3.3419;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M359.1,84.5c0-10.8,8.6-19.5,19.1-19.5c10.6,0,19.1,8.7,19.1,19.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M397.3,105.6c0,10.9-8.6,19.6-19.1,19.6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M354,102.8c-8.4,0-15.2-8.6-15.2-19.1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M378.1,103c-10.5,0-19.1-8.5-19.1-19.1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M287,84.2c0-10.5,8.5-19.1,19.1-19.1c10.5,0,19.1,8.5,19.1,19.1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M287,84v21.6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M325.1,83.5v22.1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M471,80.1v25.5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M440.6,72.5v33.1"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M410.2,79.4v26.1"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M338.8,62.5v21.9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M504.6,103.2h-4.4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M382,103h-4.1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M378.6,125.2H370"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M397.3,84.3v21.9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M481.3,84.7c0-10.8,8.6-19.5,19.1-19.5c10.6,0,19.1,8.7,19.1,19.5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M500.4,103.2c-10.5,0-19.1-8.5-19.1-19.1"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M519.5,84.2V106"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M410.2,80.4c0-8.5,6.8-15.4,15.2-15.4c8.4,0,15.2,6.9,15.2,15.4"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M440.6,80.3c0-8.5,6.8-15.4,15.2-15.4c8.4,0,15.2,6.9,15.2,15.4"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M335,53.6c0-2.1,1.7-3.8,3.8-3.8c2.1,0,3.8,1.7,3.8,3.8c0,2.1-1.7,3.8-3.8,3.8C336.7,57.4,335,55.7,335,53.6z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M277.9,86.3l-22.6,0"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M267.2,103.1h-11.3"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M237,84.5c0-10.8,8.6-19.5,19.1-19.5c10.6,0,19,8,19,18.8"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256.1,103.1c-10.5,0-19.1-8.5-19.1-19.1"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M165.9,68.9l-27.3-16.5l-27.8,16.5l27.3,15.7L165.9,68.9z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M139.1,116.7l27.6-14.7l0.8-32.7l-28.6,16.1L139.1,116.7z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M139,117.3l-1.1-32l-27.6-15.9l-1.1,31.5L139,117.3z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M196.6,119.9V50.7"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M80.1,119.9V50.7"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M137.5,153.3l59.8-34.8"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M79.3,52.1l59.9-34.9"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M139.2,153.4l-59.9-34.9"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M138.4,85.5L196,51.9"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M138.3,85.5L80.7,51.9"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M197.4,52.1l-59.9-34.9"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M166.7,102.6V68.3"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M110.1,102.6V68.4"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M138.6,118l28.9-16.8"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M109.5,69.3L139.1,52"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M138.1,118l-28.8-16.8"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M167.2,69.3L137.5,52"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M140.7,29.3c0,1.3-1,2.3-2.3,2.3c-1.3,0-2.3-1-2.3-2.3c0-1.3,1-2.3,2.3-2.3C139.6,26.9,140.7,28,140.7,29.3z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M140.7,40.9c0,1.3-1,2.3-2.3,2.3c-1.3,0-2.3-1-2.3-2.3c0-1.3,1-2.3,2.3-2.3C139.6,38.6,140.7,39.6,140.7,40.9z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9,113c0,1.3-1,2.3-2.3,2.3c-1.3,0-2.3-1-2.3-2.3c0-1.3,1-2.3,2.3-2.3C91.9,110.7,92.9,111.8,92.9,113z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M102.7,107.5c0,1.3-1,2.3-2.3,2.3c-1.3,0-2.3-1-2.3-2.3c0-1.3,1-2.3,2.3-2.3C101.7,105.2,102.7,106.3,102.7,107.5z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M188.6,113c0,1.3-1,2.3-2.3,2.3s-2.3-1-2.3-2.3c0-1.3,1-2.3,2.3-2.3S188.6,111.7,188.6,113z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M178.9,107.5c0,1.3-1,2.3-2.3,2.3c-1.3,0-2.3-1-2.3-2.3c0-1.3,1-2.3,2.3-2.3C177.8,105.1,178.9,106.2,178.9,107.5z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M138.3,85.2v67.6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnigma);
export default __webpack_public_path__ + "static/media/enigma.7ffaab29b4a7881bf9c1cd45ea292c5a.svg";
export { ForwardRef as ReactComponent };